module.exports = __webpack_public_path__ + "static/img/Jesse-Bromwich.78ef494.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jesse-Bromwich.jpg
// module id = Rwj4
// module chunks = 0